/**
 * @returns {Object}
 */
export function autoExpand() {
    
    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attr, ctrl) => {
            
            scope.$watch(attr.ngModel, (model) => {
                
                let fakeElem = angular.element('#auto-expand-dir-fake');
                
                if (!fakeElem.length) {
                    
                    fakeElem = angular.element('<span id="auto-expand-dir-fake"></span>').hide().appendTo(document.body);
                }
                
                fakeElem.text(element.val());
                
                element.css({width: fakeElem.width()});
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/auto-expand.directive.js